import React, {useEffect, useState} from 'react';
import './appEvents.scss';
import ReactMarkdown from 'react-markdown'
import {useNavigate, useParams} from "react-router-dom";
import {EventsType} from "../../../models";
import {useGetEvents} from "../../../operations/queries/useGetEvents";
import {ReactComponent as DATE_ICON} from "../../../assets/icons/date_icon_2.svg";
import {EventCard, Button} from "../../../components";
import {removeHtml, escapeHtml} from 'util/removeHtmlFromString';
import {formatTime} from 'util/formatTime';
import {ReactComponent as ARROW_ICON} from 'assets/icons/arrow_icon.svg';

const AppEvent = () => {
    let {eventId} = useParams();
    const [event, setEvent] = useState<EventsType>({} as EventsType)
    const [otherEvents, setOtherEvents] = useState<Array<EventsType>>()
    const {data} = useGetEvents();
    const navigate = useNavigate();

    useEffect(() => {
        if (!data) return
        let eventList: Array<EventsType> = [];
        console.log({data})
        data?.forEach((eventData: any) => {
            const eventDataAttributes = eventData.attributes
            eventList.push({
                id: eventData.id,
                date: eventDataAttributes.date?.split("T")[0],
                time: eventDataAttributes.date?.split("T")[1].split(".")[0],
                venue: eventDataAttributes.venue,
                address: eventDataAttributes.venue.address,
                image: process.env.REACT_APP_BASE_URL + eventDataAttributes.image.data.attributes.url,
                title: escapeHtml(eventDataAttributes.title),
                // description: removeHtml(eventDataAttributes.description),
                description: eventDataAttributes.description,
                category: eventDataAttributes?.categories?.data?.map((category: any) => category.attributes.name)
            })
        })
        const eventForViewing = eventList.filter((currentEvent: any) => (currentEvent.id === parseInt(eventId as string)))[0]
        console.log({eventForViewing})
        setEvent(eventForViewing as EventsType)

        setOtherEvents(eventList.slice(0, 3).filter((currentEvent: any) => (currentEvent.id !== parseInt(eventId as string))))

    }, [data, eventId]);

    return (
        <div className={'view-event'}>
            {Object.keys(event).length > 0 ?
                <div className={'view-event_wrapper_wrapper '}>
                    <div className={'view-event_wrapper_top'}>
                        <div className={'view-event_wrapper_top_left'}>
                            <h1>{removeHtml(event?.title)}</h1>
                            <div className={'date'}>
                                <DATE_ICON/> <span>{event?.date}</span>
                            </div>

                            <div className={'view-event_wrapper_top_left_description'}>
                                {/*{parse(escapeHtml(event?.description))}*/}
                                <ReactMarkdown>{event?.description}</ReactMarkdown>
                            </div>
                        </div>
                        <div className={'view-event_wrapper_top_right'}>
                            <img src={event?.image} alt=""/>
                            <Button text={'Add to calendar'} type={'primary'}/>
                        </div>
                    </div>

                    <div className={'view-event_wrapper_middle'}>
                        <div className={'view-event_wrapper_middle_details'}>
                            <h2>More Details:</h2>
                            <div className={'view-event_wrapper_middle_details_section'}>
                                <span>Date:</span>
                                <p>{event?.date}</p>
                            </div>
                            <div className={'view-event_wrapper_middle_details_section'}>
                                <span>Time:</span>
                                <p>{formatTime(event?.time)}</p>
                            </div>
                            <div className={'view-event_wrapper_middle_details_section'}>
                                <span>Event Category(s): </span>
                                <div className={'view-event_wrapper_middle_details_section_categories'}>
                                    {event?.category?.map((singleCategory) => <div key={singleCategory}
                                                                                   className={'view-event_wrapper_middle_details_section_categories_category'}>
                                            {singleCategory}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'view-event_wrapper_bottom'}>
                        <div className={'view-event_wrapper_bottom_heading'}>
                            <h1>Upcoming Event & Programs</h1>

                            <div className={'view-event_wrapper_bottom_heading_cta'}
                                 onClick={() => navigate('/app/news/events')}>
                                <span>View More</span> <ARROW_ICON/>
                            </div>
                        </div>
                        <div className={'view-event_wrapper_bottom_events'}>
                            {otherEvents?.map(({id, title, image, description, date}, index) => (
                                <EventCard
                                    key={index + title}
                                    id={id}
                                    title={title}
                                    image={image}
                                    description={description}
                                    date={date}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                : <div>loading</div>}

        </div>
    );
};

export default AppEvent;
